.r8h5gt0 {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--_1qu8za20);
}
.r8h5gt1 {
  color: var(--_1qu8za21a);
  width: 122px;
}
@media screen and (min-width: 1024px) {
  .r8h5gt1 {
    width: 142px;
  }
}